import styles from "./Modal.module.scss";

const Modal = ({
	title = "",
	children,
	onClose = () => {},
	buttonLabel = "Cerrar",
	hideFooterButton = false,
	hideIcon = false,
}) => {
	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalCard} role="dialog" aria-modal="true">
				{!hideIcon ? <div className={styles.modalIcon}>i</div> : null}
				{title ? <h3 className={styles.modalTitle}>{title}</h3> : null}
				<div className={styles.modalBody}>{children}</div>
				{!hideFooterButton ? (
					<button
						type="button"
						className={styles.modalButton}
						onClick={onClose}
					>
						{buttonLabel}
					</button>
				) : null}
			</div>
		</div>
	);
};

export default Modal;
